import ApiService from 'utils/ApiCalls';
import { notification } from 'antd';

const getRiskExposure = async () => {
  try {
    const response = await ApiService.getRiskExposure();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertRiskExposure = async (riskExposure: any) => {
  try {
    const response = await ApiService.postRiskExposure(riskExposure);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getDependencyType = async () => {
  try {
    const response = await ApiService.getDependencyType();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertDependencyType = async (dependencyType: any) => {
  try {
    const response = await ApiService.postDependencyType(dependencyType);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getExposureCategory = async () => {
  try {
    const response = await ApiService.getExposureCategory();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertExposureCategory = async (exposureCategory: any) => {
  try {
    const response = await ApiService.postExposureCategory(exposureCategory);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getICTSystemCriticality = async () => {
  try {
    const response = await ApiService.getICTSystemCriticality();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertICTSystemCriticality = async (exposureCategory: any) => {
  try {
    const response =
      await ApiService.postICTSystemCriticality(exposureCategory);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getEntityRole = async () => {
  try {
    const response = await ApiService.getEntityRole();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertEntityRole = async (entity_role: any) => {
  try {
    const response = await ApiService.postEntityRole(entity_role);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getRoleType = async () => {
  try {
    const response = await ApiService.getRoleType();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertRoleType = async (entity_role: any) => {
  try {
    const response = await ApiService.postRoleType(entity_role);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getRiskSource = async () => {
  try {
    const response = await ApiService.getRiskSource();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertRiskSource = async (risk_source: any) => {
  try {
    const response = await ApiService.postRiskSource(risk_source);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getRiskLevel = async () => {
  try {
    const response = await ApiService.getRiskLevel();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertRiskLevel = async (risk_lvl: any) => {
  try {
    const response = await ApiService.postRiskLevel(risk_lvl);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getResponsibilities = async () => {
  try {
    const response = await ApiService.getResponsibilities();
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertResponsibilities = async (responsibility: any) => {
  try {
    const response = await ApiService.postResponsibilities(responsibility);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const getICTRisk = async (entity_id: any) => {
  try {
    const response = await ApiService.getICTRisk(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the data:', error);
  }
};

const insertICTRisk = async (ict_risk: any) => {
  try {
    const response = await ApiService.postICTRisk(ict_risk);

    if (response && response.status === 200) {
    } else if (response.status === 207) {
      notification.success({
        message: 'Info',
        description: response.data.errors[0].error,
        duration: 20,
      });
    }

    return response;
  } catch (error) {
    notification.error({
      message: 'Info',
      description: 'An unexpected error occurred. Please try again.',
      duration: 20,
    });
  }
};

const fetchICTSystemsByICTServices = async (entity_id: any) => {
  try {
    const response = await ApiService.getICTSystemsByICTService(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the ICT systems by ICT services:', error);
  }
};

const fetchICTSystemsByFunctions = async (entity_id: any) => {
  try {
    const response = await ApiService.getICTSystemsByFunction(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the ICT systems by Fucntions:', error);
  }
};

const getICTRiskServiceDetails = async (entity_id: any) => {
  try {
    const response = await ApiService.getICTRiskServiceDetails(entity_id);
    return response;
  } catch (error) {
    console.log(error);
    throw new Error('Failed to get the ict risk service details');
  }
};

const getICTRiskFunctionDetails = async (entity_id: any) => {
  try {
    const response = await ApiService.getICTRiskFunctionDetails(entity_id);
    return response;
  } catch (error) {
    console.log(error);
    throw new Error('Failed to get the ict risk service details');
  }
};

const fetchICTSystemsDetailsByService = async (
  entity_id: any,
  date: string,
) => {
  try {
    const response = await ApiService.getICTSystemsDetailsByService(
      entity_id,
      date,
    );
    return response;
  } catch (error) {
    console.log('Error fetching the ICT systems by ICT services:', error);
  }
};

const fetchICTSystemsDetailsByFunctions = async (
  entity_id: any,
  date: string,
) => {
  try {
    const response = await ApiService.getICTSystemsDetailsByFunction(
      entity_id,
      date,
    );
    return response;
  } catch (error) {
    console.log('Error fetching the ICT systems by Fucntions:', error);
  }
};

export default {
  getRiskExposure,
  insertRiskExposure,
  getDependencyType,
  insertDependencyType,
  getExposureCategory,
  insertExposureCategory,
  getICTSystemCriticality,
  insertICTSystemCriticality,
  getEntityRole,
  insertEntityRole,
  getRoleType,
  insertRoleType,
  getICTRisk,
  insertICTRisk,
  getRiskSource,
  insertRiskSource,
  getResponsibilities,
  insertResponsibilities,
  getRiskLevel,
  insertRiskLevel,
  fetchICTSystemsByICTServices,
  fetchICTSystemsByFunctions,
  getICTRiskServiceDetails,
  getICTRiskFunctionDetails,
  fetchICTSystemsDetailsByService,
  fetchICTSystemsDetailsByFunctions,
};
